import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";

import { auth, db } from "../firebase/config";

// Add Diet Plan
export const addDietPlan = async (plan) => {
  const gymId = auth.currentUser.uid;

  await addDoc(collection(db, "gyms", gymId, "dietPlans"), {
    ...plan,
    createdAt: new Date().toISOString(),
  });
};

// Get All Diet Plans
export const getDietPlans = async () => {
  const gymId = auth.currentUser.uid;

  const snapshot = await getDocs(collection(db, "gyms", gymId, "dietPlans"));

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Get Single Diet Plan
export const getDietPlan = async (id, gymId = auth.currentUser?.uid) => {
  const snapshot = await getDoc(doc(db, "gyms", gymId, "dietPlans", id));

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data(),
  };
};

// Update Diet Plan
export const updateDietPlan = async (id, data) => {
  const gymId = auth.currentUser.uid;

  await updateDoc(doc(db, "gyms", gymId, "dietPlans", id), data);
};

// Delete Diet Plan
export const deleteDietPlan = async (id) => {
  const gymId = auth.currentUser.uid;

  await deleteDoc(doc(db, "gyms", gymId, "dietPlans", id));
};
